import React from "react"
import styles from "./StatusBadge.module.scss"

const StatusBadge = ({ statusName, revenue = false }) => {
  const formattedStatusName = statusName.toLowerCase().replace(/\s+/g, "-")

  return <div className={`${styles.statusBadge} ${styles[`statusBadge-${revenue ? "revenue" : formattedStatusName}`] || ""}`}>{statusName}</div>
}

export default StatusBadge
